import {
  selectBombBomb,
  selectBombBombStatus,
  setBombBombStep,
  setBombBombVideo
} from '../../../../store/slices/bombBomb'
import classnames from 'classnames'
import { useState, useEffect } from 'react'
import { SAVE } from '../../../../types/bombBomb'
import { BotHeadSpin } from '../../../../Components'
import { useDispatch, useSelector } from 'react-redux'
import { FAILED } from '../../../../types/loadingStatus'
import { BombBombPanelVideoError } from './BombBombPanelVideoError'

import styles from './BombBombPanelVideo.module.scss'

export const BombBombPanelVideo = () => {
  const dispatch = useDispatch()
  const bombBomb = useSelector(selectBombBomb)
  const status = useSelector(selectBombBombStatus)
  const [recorderLoaded, setRecorderLoaded] = useState(false)

  useEffect(() => {
    bombBomb?.startVideoRecorder?.(
      {
        target: '#recorder',
        width: 360,
        recorderLoaded: () => setRecorderLoaded(true)
      },
      video => {
        dispatch(setBombBombVideo(video))
        dispatch(setBombBombStep(SAVE))
      }
    )
  }, [bombBomb, dispatch])

  return (
    <div className={classnames(styles.preview, status === FAILED && styles.errorPreview)}>
      {!recorderLoaded && status !== FAILED && <BotHeadSpin />}
      {status === FAILED && <BombBombPanelVideoError />}
      <div id='recorder' data-qa='recorder' className={recorderLoaded ? styles.recorder : ''} />
    </div>
  )
}
